// propertyIDandSNSlice.js

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  uid: '',
  propertyId: "",
  propertySecureNum: "",
};

const propertyIDandSNSlice = createSlice({
  name: "propertyIDandSN",
  initialState,
  reducers: {
    setUid: (state, action) => {
      state.uid = action.payload
    },
    setPropertyDetails: (state, action) => {
      state.propertyId = action.payload.propertyId;
      state.propertySecureNum = action.payload.propertySecureNum;
    },
  },
});

export const { setPropertyDetails, setUid } = propertyIDandSNSlice.actions;

export const selectUid = (state) => state.propertyIDandSN.uid;
export const selectPropertyId = (state) => state.propertyIDandSN.propertyId;
export const selectPropertySecureNum = (state) =>
  state.propertyIDandSN.propertySecureNum;

export default propertyIDandSNSlice.reducer;
